<template>
	<div class="checkbox-button">
		<label>
			<input
				type="checkbox"
				:id="this.id"
				:value="this.value"
				:checked="this.checked"
				:disabled="this.isDisabled"
				@click="getValue($event.target.id, $event.target.value, $event)"
			/>
			<span>
				<span
					v-if="type == 'equipmentlevel' || type == 'activitylevel'"
					:class="['checkbox-button__color', `checkbox-button__color--${id}`]"
				></span>
				<span class="checkbox-button__text">
					{{ value }}
					<template v-if="type == 'equipmentlevel'">
						{{ description }}
					</template>
				</span>
			</span>
		</label>
	</div>
</template>

<script>
export default {
	name: 'CheckboxButton',
	props: {
		value: {
			type: String,
			default: ''
		},
		description: {
			type: String,
			default: ''
		},
		type: {
			type: String,
			default: ''
		},
		id: {
			type: Number,
			default: 0
		},
		model: {
			type: Array,
			default: () => []
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		checked: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		getValue(id) {
			this.$emit('click-input', parseInt(id))
		}
	}
}
</script>

<style scoped lang="scss">
.checkbox-button {
	display: inline-block;
	//overflow:auto;
	border: 1px solid rgba(42, 62, 97, 0.2);
	border-radius: 3px;
	background-color: #ffffff;
	box-shadow: inset 0 0 1px 0 rgba(0, 0, 0, 0.2);
	color: $colorPrimary;
	font-family: Saira;
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 21px;
	margin: 0 5px 5px 0;

	@include for-tablet-landscape-up {
		margin: 0 5px 0 0;
	}

	label {
		float: left;
		cursor: pointer;
	}

	label input + span {
		display: block;
		padding: 4px 10px;
		border-radius: 3px;
	}

	label input {
		// position:absolute;
		// top:-20px;
		display: none;
	}

	input:checked + span {
		background-color: $colorPrimary;
		color: $colorPrimary1;
	}
	input:disabled + span {
		background: $colorGrey1;
		color: $colorPrimary3;
		cursor: context-menu;
	}

	&__text {
		display: inline-block;
		vertical-align: middle;
	}

	&__color {
		display: inline-block;
		height: 12px;
		width: 12px;
		border-radius: 2px;
		margin: 0 8px 0 0;
		vertical-align: middle;
		&--1,
		&--2048 {
			background-color: #64c7bc;
		}
		&--2,
		&--2049 {
			background-color: #04befb;
		}
		&--3,
		&--2050 {
			background-color: #b9003c;
		}
		&--2051 {
			background-color: #000;
		}
		&--2063 {
			background: repeating-linear-gradient(
				-45deg,
				#000,
				#000 2px,
				#fff 2px,
				#fff 4px
			);
		}
	}
}
</style>
